module.exports = __webpack_public_path__ + "static/media/gerbera.17da3c62.webp";